import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/job/:jobId/importedIds` | `${typeof baseRoute}/job/${number}/importedIds`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId/importedIds`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}/importedIds`;
